import {
  AEROPLANE_LOADER_GETTERS_ENUM,
} from './aeroplane-loader.eum';

export const aeroplaneLoaderGetters = {
  [AEROPLANE_LOADER_GETTERS_ENUM.GET_SHOW_AEROPLANE](state) {
    return state.showAeroplane;
  },
};
